import { Box, Grid, Typography } from "@mui/material";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined';

interface ICardInfo {
    name: string;
    cpf: string;
    birthdate: string;
    cep: string;
    street: string;
    number: string;
    email: string;
    cellphone: string;
}
export default function LeadInfo(prop: ICardInfo) {
  return (
    <Grid container direction='column' sx={{
      maxWidth: 300,
      border: 2,
      borderColor: 'primary.main',
      borderRadius: 3,
      alignItems:'center', 
      margin: '10px auto'}}>
    <Box sx={{ margin: '10px auto'}}>
    <Typography variant="h6"color='primary.main'>
      Seus Dados:
    </Typography>
    </Box>
    <Box sx={{
      width: '80%', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'flex-start',
      mb: 1}}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <AccountCircleOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.name}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <ArticleOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.cpf}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <CalendarTodayOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.birthdate}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <MapOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.cep}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <HomeOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.street}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <PinDropOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.number}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <AlternateEmailOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.email}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <ArticleOutlinedIcon sx={{ color: "#656565", mr: 1, mb:1}}/>
        <Typography variant="body2" color="text.secondary">
            {prop.cellphone}
        </Typography>
      </Box>
    </Box>
  </Grid>
  )
}